export const DISPLAY_PRESETS = {
  orbit: { name: "Orbit", bg: "#0B2A5B", bg2: "#02050F", accent: "#F28C28", accent2: "#5CC8E8", text: "#ffffff", stars: true, nebula: true },
  sahara: { name: "Sáhara", bg: "#7A3E12", bg2: "#1a0c04", accent: "#F2C94C", accent2: "#FF8A5B", text: "#fff7ea", stars: false },
  emerald: { name: "Esmeralda", bg: "#0b3d2e", bg2: "#02110c", accent: "#7CFFB2", accent2: "#F2C94C", text: "#ffffff", stars: true },
  royal: { name: "Azul real", bg: "#1b2a6b", bg2: "#060a1f", accent: "#7FB3FF", accent2: "#FFD166", text: "#ffffff", stars: true },
  rose: { name: "Rosa", bg: "#6b1b3a", bg2: "#1f050f", accent: "#FF9ECF", accent2: "#FFE066", text: "#ffffff", stars: false },
  light: { name: "Claro", bg: "#eef3f8", bg2: "#ffffff", accent: "#1F9D55", accent2: "#B9651A", text: "#0F2A3A", stars: false },
};

export const resolveTheme = (theme) => {
  const base = DISPLAY_PRESETS[theme?.preset] || DISPLAY_PRESETS.orbit;
  return { ...base, ...(theme?.preset === "custom" ? theme : {}), bg_image_id: theme?.bg_image_id || null, stars: theme?.stars ?? base.stars, nebula: !!base.nebula && !theme?.bg_image_id, dim: theme?.dim ?? 0.45 };
};

const hex2rgb = (h) => { const m = String(h || "").replace("#", ""); const v = m.length === 3 ? m.split("").map((c) => c + c).join("") : m; const n = parseInt(v || "ffffff", 16); return `${(n >> 16) & 255},${(n >> 8) & 255},${n & 255}`; };

export const themeVars = (th) => ({
  "--cd-bg": th.bg, "--cd-bg2": th.bg2, "--cd-accent": th.accent, "--cd-accent2": th.accent2, "--cd-text": th.text,
  "--cd-accent-rgb": hex2rgb(th.accent), "--cd-accent2-rgb": hex2rgb(th.accent2), "--cd-text-rgb": hex2rgb(th.text), "--cd-dim": th.dim,
});
